require('./categories-container.scss')

module.exports = {
  template: require('./categories-container.pug')()
  controller: require('./categories-container.ctrl')
}
